import CvSearchPackage from "../../components/cvSeachPackage/CvSearchPackage"

function CvSearchPackagePage() {
    return (
        <>
        <CvSearchPackage/>
        </>
    )
}
export default CvSearchPackagePage